// Core
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Styles
import './styles.scss';

// Assets
import Logo from 'assets/images/logo.jpg'

import { restAPIs } from 'utils/restAPIs';
import { fetchData } from 'utils/fetch';
import { useSelector } from 'react-redux';
import ReactPlayer from 'react-player';
import { Fade } from 'react-reveal';
import { APP_ID } from 'config/constants';
import Button from 'components/commonComponents/Button';
import SocialShare from 'components/modals/SocialShare';
import Loader from 'components/commonComponents/Loader';


const ReferAndEarn = () => {
    const { currentLang, userDetails } = useSelector((store) => store.commonData);
    const { t } = useTranslation();
    const [isLoading, setLoading] = useState(false);
        const [openShareSocial, setOpenShareSocial] = useState(false);
    const [data, setData] = useState({});
    const [appInfo, setAppInfo] = useState(null);
        const [summary, setSummary] = useState('');

    const fetchWallet = async () => {
        const res = await fetchData(restAPIs.getWallet(APP_ID, currentLang?.id));
        if (res.statusCode === 200) {
            setData(res)
        }
        setLoading(false);
    }

    const fetchAppinfo = async () => {
        const res = await fetchData(restAPIs.getAppInfo(APP_ID, currentLang?.id));
        if (res?.appInfo) {
            const tempRes=res?.appInfo
            setAppInfo(tempRes)
            var temp_appInfo = tempRes;
            var appStoreLink = temp_appInfo.appStoreLink ? temp_appInfo.appStoreLink : '';
            var googleStoreLink = temp_appInfo.googleStoreLink
              ? temp_appInfo.googleStoreLink
              : '';
            var websitelink = temp_appInfo.websitelink ? temp_appInfo.websitelink : '';
            var name = temp_appInfo.name ? temp_appInfo.name : '';
            var footer =
              '\n' +
              '\n' +
              'From Cinema Project. ' +
              '\n' +
              'By Electronic Village...' +
              '\n';
            var refCode = userDetails?.refCode;
            var link =
              'Discounted Subscription :' +
              '\n' +
              'com.cinema://RefCode/' +
              refCode +
              '\n' +
              '\n' +
              'Enter my Referral Code is ' +
              refCode +
              ' to get discounts';
            var subbody = temp_appInfo.description;
            subbody = subbody.replace(/<style([\s\S]*?)<\/style>/gi, '');
            subbody = subbody.replace(/<script([\s\S]*?)<\/script>/gi, '');
            subbody = subbody.replace(/<\/div>/gi, '\n');
            subbody = subbody.replace(/<\/li>/gi, '\n');
            subbody = subbody.replace(/<li>/gi, '  *  ');
            subbody = subbody.replace(/<\/ul>/gi, '\n');
            subbody = subbody.replace(/<\/p>/gi, '\n');
            subbody = subbody.replace(/<br\s*\/?>/gi, '\n');
            subbody = subbody.replace(/<[^>]+>/gi, '');
            subbody = subbody.replace(/&nbsp;/gi, '');
            subbody =
              name +
              '\n\n' +
              subbody +
              '\n\n' +
              'App Store: ' +
              appStoreLink +
              '\n\n' +
              'Play Store: ' +
              googleStoreLink +
              '\n\n' +
              'Web Site: ' +
              websitelink +
              '\n\n' +
              link +
              footer;
              setSummary(subbody)
            
        }
        setLoading(false);
    }

    useEffect(() => {
        setLoading(true)
        fetchWallet();
        fetchAppinfo();
        window.scrollTo(0, 0);
    }, [currentLang]);

    const handleCloseShareSocial = () => {
        setOpenShareSocial(false);
    };

    const handleOpenShareSocial = () => {
        setOpenShareSocial(true);
    };

    return (
        <>
            <div className='container __innerTopPad'>
                {isLoading ?
                    <Loader /> :
                    <div className='row'>
                        <Fade bottom cascade>
                            <div className='col-md-3 mb-5'>
                                <img src={Logo} alt="" width={'100%'} height={'200px'} style={{ objectFit: 'contain' }} />
                            </div>
                        </Fade>
                        <Fade bottom cascade>
                            <div className='col-md-9 mb-5'>
                                <h4 style={{ color: '#a19c74', marginBottom: '10px' }}>{t('refer_earn')}</h4>
                                <h1 className='__common-head' style={{ color: '#e3a83a', fontSize: '2rem' }}>{t('wallet_money')} : {data?.wallet} USD</h1>
                                <p dangerouslySetInnerHTML={{ __html: data?.description }} style={{ lineHeight: '2', fontSize: '17px' }}></p>
                                {data?.videoURL ? <div className='row justify-content-center'>
                                    <div className='col-md-8'>
                                        <div className='player-wrapper'>
                                            <ReactPlayer url={data?.videoURL} controls={true}
                                                className='react-player'
                                                width='100%'
                                                height='100%'
                                            />
                                        </div>
                                    </div>
                                </div> : ''}

                                <div className='footer_button'> 
                                    <Button
                                        className='mb-1'
                                        style={{ width: '100%', height: '40px', background: '#e3a83a' }}
                                        label='Cash Out' />
                                    <Button
                                    className='mb-1'
                                    handleOnClick={handleOpenShareSocial}
                                    style={{ width: '100%', height: '40px', background: '#d3044a' }}
                                    label='Share Now' />
                                </div>
                            </div>
                        </Fade>
                    </div>
                }
<SocialShare
                                                        open={openShareSocial}
                                                        onClose={handleCloseShareSocial}
                                                        title={appInfo?.name}
                                                        description={appInfo?.description}
                                                        image={appInfo?.logo}
                                                        url={window.location.href}
                                                        summary={summary}
                                                    />

            </div>
        </>
    );
};

export default ReferAndEarn;
